import React, { useContext, useEffect, useState } from "react";
import { View, TouchableOpacity } from "react-native";
import YoutubePlayer from "react-native-youtube-iframe";
import IonIcons from "react-native-vector-icons/Ionicons";
import Wrapper from "../../../components/wrapper";
import { markTaskAsCompleted } from "../../../utils/user";
import QualtricsTask from "../../../components/qualtrics-task";
import LoginContext from "../../../hooks/loginContext";
import { TranslateText } from "../../../components/translate-text";
import SubmitConfirmationModal from "../../../components/submit-confirmation-modal";

const SubTask = ({ setIndex, task }) => {
  const { user } = useContext(LoginContext);
  const [isModalVisible, setIsModalVisible] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const completeTask = async () => {
    await markTaskAsCompleted(user.user_id, task.id);
    setIndex(3);
  };
  const goBack = async () => {
    if (task.qualtricsLink) {
      setIsModalVisible({
        title: "Are you sure?",
        subtitle: "Do you want to submit the task before leaving the page?.",
        callback: () => {
          completeTask();
        },
        cancelCallback: () => {
          setIsModalVisible(false);
          setIndex(3);
        },
        button_name: "Submit",
        cancel_button_name: "Come Back Later",
      });
    } else {
      setIndex(3);
    }
  };
  return (
    <Wrapper>
      {isModalVisible ? (
        <SubmitConfirmationModal
          loading={false}
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
          isSubmitted={isSubmitted}
        />
      ) : null}
      <View
        style={{
          marginVertical: 8,
          position: "absolute",
          top: 40,
          left: 40,
          zIndex: 999999,
        }}
      >
        <IonIcons
          onPress={() => {
            goBack();
          }}
          name="arrow-back"
          size={20}
          color={"#000"}
        />
      </View>
      <TranslateText
        style={{
          fontSize: 28,
          marginVertical: 8,
          position: "absolute",
          top: 40,
          width: "100%",
          textAlign: "center",
        }}
      >
        Hollo DigiACT
      </TranslateText>
      <View
        style={{
          height: "85%",
          backgroundColor: "transparent",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: 8,
          width: "100%",
          top: 40,
          overflow: "hidden",
        }}
      >
        <View
          style={{
            backgroundColor: "#FFF",
            paddingHorizontal: 0,
            paddingVertical: 12,
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            width: "100%",
            shadowColor: "rgba(0,0,0)",
            shadowOpacity: 0.2,
            shadowOffset: { height: 0 },
            marginVertical: 4,
          }}
        >
          <TranslateText
            style={{
              fontWeight: "700",
              fontSize: 16,
              lineHeight: 19,
              paddingLeft: 12,
            }}
          >
            <TranslateText>Task </TranslateText>
            {Number(task.id) + 1}.1
          </TranslateText>
        </View>
        {task.qualtricsLink && (
          <QualtricsTask task={task} completeTask={null} />
        )}
        {task.youtubeLink && (
          <View
            style={{
              backgroundColor: "#FFF",
              paddingHorizontal: 8,
              paddingVertical: 12,
              width: "100%",
              shadowColor: "rgba(0,0,0)",
              shadowOpacity: 0.2,
              shadowOffset: { height: 0 },
              margin: 4,
              alignItems: "center",
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 12,
            }}
          >
            <YoutubePlayer
              height={160}
              width={280}
              play={false}
              videoId={task.youtubeLink}
            />
          </View>
        )}
        {task.youtubeLink && (
          <View style={{ width: "100%", marginTop: 12 }}>
            <View
              style={{
                backgroundColor: "#FFF",
                paddingHorizontal: 8,
                paddingVertical: 12,
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
                width: "100%",
                shadowColor: "rgba(0,0,0)",
                shadowOpacity: 0.2,
                shadowOffset: { height: 0 },
                margin: 4,
              }}
            >
              <TranslateText
                style={{ fontWeight: "700", fontSize: 16, lineHeight: 19 }}
              >
                <TranslateText>Task</TranslateText> {Number(task.id) + 1}.2
              </TranslateText>
            </View>
            <View
              style={{
                backgroundColor: "#FFF",
                paddingHorizontal: 8,
                paddingVertical: 12,
                width: "100%",
                shadowColor: "rgba(0,0,0)",
                shadowOpacity: 0.2,
                shadowOffset: { height: 0 },
                margin: 4,
                borderBottomLeftRadius: 12,
                borderBottomRightRadius: 12,
              }}
            >
              <TranslateText
                style={{ fontWeight: "bold", fontSize: 24, marginBottom: 8 }}
              >
                Video Journal
              </TranslateText>
              <TranslateText style={{ fontSize: 16 }}>
                After watching the above video, please complete this video
                journal. Take off your mask and complete this task somewhere
                quiet and where you feel safe.
              </TranslateText>
              <TouchableOpacity
                style={{ width: "100%" }}
                onPress={() => {
                  setIndex(5);
                }}
              >
                <TranslateText
                  style={{
                    textAlign: "right",
                    width: "100%",
                    color: "#33CF71",
                  }}
                >
                  START
                </TranslateText>
              </TouchableOpacity>
            </View>
          </View>
        )}
      </View>
    </Wrapper>
  );
};

export const StartButton = ({ navigation }) => {
  return (
    <TouchableOpacity
      onPress={() => {
        navigation.navigate("Video Journal");
      }}
      style={{
        backgroundColor: "#33CF71",
        borderRadius: 20,
        marginTop: 8,
        padding: 4,
      }}
    >
      <View style={{ alignItems: "center" }}>
        <TranslateText style={{ color: "#FFF", fontSize: 11 }}>
          START
        </TranslateText>
      </View>
    </TouchableOpacity>
  );
};

export const CompleteButton = () => {
  return (
    <TouchableOpacity
      onPress={() => {}}
      style={{
        backgroundColor: "transparent",
        borderRadius: 20,
        marginTop: 8,
        padding: 4,
      }}
    >
      <View style={{ alignItems: "center" }}>
        <TranslateText style={{ color: "#000", fontSize: 11 }}>
          Complete
        </TranslateText>
      </View>
    </TouchableOpacity>
  );
};

export const LockedButton = () => {
  return (
    <TouchableOpacity
      onPress={() => {}}
      style={{
        backgroundColor: "transparent",
        borderRadius: 20,
        marginTop: 8,
        padding: 4,
      }}
    >
      <View style={{ alignItems: "center" }}>
        <TranslateText style={{ color: "#000", fontSize: 11 }}>
          Unlocks in n day(s)
        </TranslateText>
      </View>
    </TouchableOpacity>
  );
};

export default SubTask;
